import React from 'react'
import { Link } from 'react-router-dom'
import FormFactory from '../../../../components/form/form-factory'

import {
  Header,
  Section,
  Container,
  H3,
  Article,
  WrapperHeader,
} from './styles'
import arrowLeft from '../../../../assets/svg/arrow-left-line.svg'
import FAQ from '../../../../assets/svg/FAQ.svg'

import IFormPage from '../../../../interfaces/form-page'
import logoIntro from '../../../../assets/png/logo-intro.png'

type IProps = any & IFormPage

const Signup3Contractor = ({
  dataForm,
  onSubmit,
  errorMessage,
  backButton,
}: IProps): JSX.Element => (
  <>
    <Link to="/signup2/contractor" style={{ textDecoration: 'none' }}>
      <Header>
        <img src={arrowLeft} alt="Voltar" />
        Cadastro
      </Header>
    </Link>
    <Container>
      <WrapperHeader>
        <img src={logoIntro} alt="Logo" width="30%" />
        <Link to="/faq/CONTRATANTE">
          <img src={FAQ} alt="FAQ" />
        </Link>
      </WrapperHeader>
      <Section>
        Passo 3 de 3
        <H3>
          Adicione seu&nbsp;
          <Article>endereço</Article>
        </H3>
      </Section>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
        backButton={backButton}
      />
    </Container>
  </>
)

export default Signup3Contractor
